import { useEffect } from "react";
import Lenis from "lenis";
import Hero from "./Hero";
import Marquee from "./Marquee";
import ProblemSolution from "./ProblemSolution";
import MidCTA from "./MidCTA";
import Chapters from "./Chapters";
import Benefits from "./Benefits";
import Offer from "./Offer";
import LeadForm from "./LeadForm";
import FAQ from "./FAQ";
import Footer from "./Footer";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const anchors = document.querySelectorAll('a[href^="#"]');
    const onClick = (e) => {
      const id = e.currentTarget.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -20 });
      }
    };
    anchors.forEach((a) => a.addEventListener("click", onClick));

    return () => {
      cancelAnimationFrame(raf);
      anchors.forEach((a) => a.removeEventListener("click", onClick));
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-[#0A0A0A]">
      <Hero />
      <Marquee />
      <ProblemSolution />
      <MidCTA
        testid="midcta-after-problem"
        text="Cansado de tentar sem método? O caminho existe — e cabe na sua rotina."
      />
      <Chapters />
      <MidCTA
        testid="midcta-after-chapters"
        text="8 capítulos, um único caminho: do zero ao seu primeiro cliente."
      />
      <Benefits />
      <MidCTA
        testid="midcta-after-benefits"
        text="Tudo o que você precisa em um só guia. Comece hoje por R$ 17,97."
      />
      <Offer />
      <LeadForm />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Landing;
